import React from 'react';
import styles from './CalculatorLayout.module.css';

interface CalculatorLayoutProps {
    children: React.ReactNode;
}

const CalculatorLayout: React.FC<CalculatorLayoutProps> = ({ children }) => {
    return (
        <div className={styles.layout}>
            <main className={styles.main}>
                {children}
            </main>
        </div>
    );
};

export default CalculatorLayout; 